import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "popup__wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "popup__title"
}
const _hoisted_3 = {
  key: 1,
  class: "popup__desc"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconTimes = _resolveComponent("IconTimes")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock("output", {
    role: "status",
    class: _normalizeClass(["popup", {
			danger: _ctx.type === 'danger',
			warning: _ctx.type === 'warning',
			success: _ctx.type === 'success',
		}])
  }, [
    _withDirectives((_openBlock(), _createElementBlock("button", {
      class: "btn btn-tertiary btn-sm modal__btn",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closePopup && _ctx.closePopup(...args))),
      "aria-label": "Закрыть поп-ап"
    }, [
      _createVNode(_component_IconBase, null, {
        default: _withCtx(() => [
          _createVNode(_component_IconTimes)
        ]),
        _: 1
      })
    ])), [
      [_directive_ripple]
    ]),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.title)
        ? (_openBlock(), _createElementBlock("h2", _hoisted_2, _toDisplayString(_ctx.title), 1))
        : _createCommentVNode("", true),
      (_ctx.desc)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.desc), 1))
        : _createCommentVNode("", true)
    ])
  ], 2))
}